<template>
  <div>
    <NavigationBar />
    <CarouselView />
    <div class="row body_content">
      <div class="col d-flex justify-content-center">
        <div class="card custom-card">
          <img src="../assets/rating.jpg" class="card-img-top" alt="...">
          <div class="card-body centered-container">
            <p class="card-text">Tell Us About Your Experience</p>
            <button class="btn btn-primary" @click="this.$router.push('/send-feedback')">Rate Us</button>
          </div>

        </div>
      </div>
      <div class="col d-flex justify-content-center">
        <div class="card custom-card">
          <img src="../assets/shopping-bag.jpg" class="card-img-top" alt="...">
          <div class="card-body centered-container">
            <p class="card-text">Find Your Next Bargain</p>
            <button href="#" class="btn btn-primary" @click="this.$router.push('/allProducts')">Shop</button>
          </div>

        </div>
      </div>
      <div class="col d-flex justify-content-center">
        <div class="card custom-card">
          <img src="../assets/payment.jpg" class="card-img-top" alt="...">
          <div class="card-body justify-content-center">
            <p class="card-text">Save and earn with our store credit card.</p>
            <button class="btn btn-primary" @click="this.$router.push('/credit')">Apply Now</button>
          </div>

        </div>
      </div>
    </div>
    <FooterView/>
  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue';
import CarouselView from '../components/Carousel.vue';
import FooterView from '../components/Footer.vue'

export default {
  name: 'HomeScreen',
  components: {
    NavigationBar,
    CarouselView,
    FooterView
  },
  data() {
    return {
      itemsInCart: 0,
      productData: Array
    }
  },
  methods: {
    incrementCount() {
      this.$store.dispatch('increment')
    },
    decreaseCount() {
      this.itemsInCart--
    }
  },
  async mounted() {

    // fetch('https://fakestoreapi.com/products')
    //   .then(response => response.json())
    //   .then(data => {

    //     this.productData = data.filter(data => data.category.includes("clothing"));
    //     console.log(JSON.stringify(this.productData))
    //     // return data
    //   });
    // getAllProducts()
    //   .then(data => {
    //     this.productData = data;
    //     console.log('Product Data:', data);
    //   })
    //   .catch(error => {
    //     console.error('Failed to fetch products:', error);
    //   });
  },

}
//Electronics image: Photo by <a href="https://unsplash.com/@impulse9696?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Davide Boscolo</a> on <a href="https://unsplash.com/photos/black-sony-wireless-headphones-on-black-computer-keyboard-gz9njd0zYbQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
//Clothing image: Photo by <a href="https://unsplash.com/@hannahmorgan7?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Hannah Morgan</a> on <a href="https://unsplash.com/photos/assorted-color-hanging-clothes-lot-ycVFts5Ma4s?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>

</script>

<style scoped>
.custom-card {
  display: flex;
  width: 300px;
  height: 350px !important;
  text-align: center;
}

.body_content {
  margin-top: 20px;
  margin-bottom: 20px;
}


</style>